import { createClassName } from 'utils/createClassName';

import './adminNotificationPanelLayoutStyles.scss';

export const createAdminNotificationPanelLayoutClassName = createClassName(
  'adminNotificationPanelLayout'
);
